import { BaseDto } from './base.dto';
import { UserDto } from './user.dto';

export class ApiKeyDto extends BaseDto {
  name?: string;
  identifier?: string;
  active?: boolean;
  user: UserDto;
  userId: number;
  isThirdParty: boolean;
  thirdPartyType: number;
}
